import { MNSproCloudApi } from '..';
import {
  ClassRegisterPrefs,
  ClassRegisterUserPreferenceModulePatchPayload,
  OnePropertyOf,
  UserPreferencesModules,
} from './userPreferences.interfaces';

export class ClassRegisterPreferencesService {
  static async patchModule(
    authToken: string,
    value: ClassRegisterUserPreferenceModulePatchPayload,
  ) {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.UserPreferencesApiFactory(config);

    const rights = await api.patchModule(
      UserPreferencesModules.Classbook,
      value.classbook,
    );
    return rights.data as ClassRegisterUserPreferenceModulePatchPayload;
  }

  static async patchSettings(
    authToken: string,
    value: OnePropertyOf<ClassRegisterPrefs>,
  ) {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.UserPreferencesApiFactory(config);

    const rights = await api.patchModule(
      UserPreferencesModules.Classbook,
      value,
    );
    return rights.data as OnePropertyOf<ClassRegisterPrefs>;
  }
}
